import { QBoxStylesRFC } from "./QBoxStylesRFC";

export class QUploadBoxStylesRFC extends QBoxStylesRFC {
  constructor(onResult) {
    super();
    this._onResult = onResult;
  }

  InitUploadBSRFC() {
    super.InitUploadBSRFC(this);
  }

  UploadBoxStylesResult(success) {
    this._onResult(success);
  }

  DoTransactionFailed() {
    this.UploadBoxStylesResult(false);
  }

  DoSessionEnded() {
    this.UploadBoxStylesResult(false);
  }
}
